import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { toast } from "sonner";
import { Terminal } from "lucide-react";
import { useAuth, formatApiErrorDetail } from "@/lib/auth";
import { LOGO_MARK } from "@/lib/assets";
import { btnPrimary, input, label } from "@/lib/styles";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      const u = await login(email, password);
      toast.success("Logged in");
      navigate(u.placement_completed ? (location.state?.from || "/curriculum") : "/onboarding");
    } catch (e2) {
      setErr(formatApiErrorDetail(e2.response?.data?.detail) || e2.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center grid-bg px-4">
      <div className="w-full max-w-md bg-zinc-950 border border-zinc-800 p-8 scanlines relative">
        <Link to="/" className="flex items-center gap-2 mb-8"><img src={LOGO_MARK} alt="" className="w-8 h-8" /><span className="font-sans font-bold text-xl tracking-tight text-zinc-100">Prompt<span className="text-gold">bound</span></span></Link>
        <span className={label}>welcome back</span>
        <h1 className="mt-2 text-2xl font-black tracking-tight mb-6">Log in</h1>
        <form onSubmit={submit} className="space-y-4">
          <input data-testid="login-email" className={input} type="email" placeholder="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
          <input data-testid="login-password" className={input} type="password" placeholder="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
          {err && <p data-testid="login-error" className="text-red-400 text-xs font-mono">! {err}</p>}
          <button data-testid="login-submit" type="submit" disabled={loading} className={`${btnPrimary} w-full`}>{loading ? "authenticating..." : "Log in"}</button>
        </form>
        <p className="mt-6 text-xs text-zinc-500 text-center">No account? <Link to="/register" className="text-emerald-400 hover:underline" data-testid="login-to-register">Create one free</Link></p>
      </div>
    </div>
  );
}
